<template>
  <div class="RelatorioItem row mt-1 p-2 pl-0 mr-0 ml-0"
       @click="showItens = !showItens">
    <div class="col-8 ">
      {{ propRelatorio.nome }} - {{ propPeriodoInicial | date }} até {{ propPeriodoFinal | date }}
    </div>
    <div class="col-2 d-flex justify-content-center">
      {{ propRelatorio.total_qtd_notas }}
    </div>
    <div class="col-2 d-flex justify-content-end">
      {{ propRelatorio.total_item | moneyToString }}
    </div>
    <div v-if="showItens && propRelatorio.consulta.length"
         class="tabela">
      <b-table :items="items"
               :fields="fields"
               :borderless="true"
               :outlined="true"
               small
               hover>
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style=" { width: field.key === 'tipo_registro' ? '400px' : '80px' } ">
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ServicosRecolhimentosNotasToggle",
    props: {
      propRelatorio: {type: Object, default: () => ({})},
      propPeriodoInicial: {type: String, default: null},
      propPeriodoFinal: {type: String, default: null}
    },
    data () {
      return {
        showItens: false,
        items: [],
        fields: [
          { key: 'tipo_registro', label: 'Tipo Registro', tdClass: 'text-left' },
          { key: 'quantidade', label: 'Qtde.', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'tabeliao', label: 'Tabelião', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'estado', label: 'Ao Estado', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'ipesp', label: 'A Sec. Faz.', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'santacasa', label: 'A Sta Casa', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'registrocivil', label: 'Ao Reg Civil', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'tribunaljustica', label: 'Ao Trib. Justiça', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'iss', label: 'Imp. Mun.', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'ministeriopublico', label: 'Ao Min. Público', tdClass: 'text-center', thClass: 'text-center' },
          { key: 'total', label: 'Total Item', isRowHeader: true, tdClass: 'text-center', thClass: 'text-center' },
        ],
        tableVariants: {

        }
      }
    },
    async created () {
      for (const dados of this.propRelatorio.consulta) {
        this.items.push({
          tipo_registro: dados.tipo_registro,
          quantidade: dados.quantidade,
          tabeliao: dados.destino.tabeliao ? await this.convertCents(dados.destino.tabeliao) : '0,00',
          estado: dados.destino.estado ? await this.convertCents(dados.destino.estado) : '0,00',
          ipesp: dados.destino.ipesp ? await this.convertCents(dados.destino.ipesp) : '0,00',
          santacasa: dados.destino.santacasa ? await this.convertCents(dados.destino.santacasa) : '0,00',
          registrocivil: dados.destino.registrocivil ? await this.convertCents(dados.destino.registrocivil) : '0,00',
          tribunaljustica: dados.destino.tribunaljustica ? await this.convertCents(dados.destino.tribunaljustica) : '0,00',
          iss: dados.destino.iss ? await this.convertCents(dados.destino.iss) : dados.destino.municipio ? await this.convertCents(dados.destino.municipio) : '0,00',
          ministeriopublico: dados.destino.ministeriopublico ? await this.convertCents(dados.destino.ministeriopublico) : '0,00',
          total: dados.total ? await this.convertCents(dados.total) : '0,00'
        })
      }
    },
    methods: {
      async convertCents (cents) {
        let valor
        valor = (cents / 100).toLocaleString('pt-br', {minimumFractionDigits: 2})
        return valor
      }
    }
  }
</script>

<style scoped>
.tabela {
  font-size: 0.97rem;
}

.RelatorioItem {
  border-bottom: 1px solid #696969;
  border-radius: 3px;
}

</style>
